<template>
  <el-dialog :title="title" :visible.sync="visibleInner" width="440px" append-to-body @closed="handleClosed">
    <div v-loading="loading" class="mr-qr-body">
      <div v-if="roomName" class="mr-qr-meta">{{ roomName }}</div>
      <div v-if="subject" class="mr-qr-sub">{{ subject }}</div>
      <div class="mr-qr-img-wrap" v-loading="qrRendering">
        <img v-if="qrImageUrl" :src="qrImageUrl" class="mr-qr-img" alt="二维码" />
        <div v-else-if="!loading && !qrRendering" class="mr-qr-empty">暂无二维码</div>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="visibleInner = false">关闭</el-button>
      <el-button type="primary" :disabled="!qrImageUrl" @click="downloadQr">下载 PNG</el-button>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from 'qrcode';

export default {
  name: 'MeetingRoomQrDialog',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '二维码' },
    loading: { type: Boolean, default: false },
    qrData: { type: Object, default: null },
    downloadPrefix: { type: String, default: '会议室二维码' }
  },
  data() {
    return {
      qrImageUrl: '',
      qrRendering: false,
      qrRenderSeq: 0
    };
  },
  computed: {
    visibleInner: {
      get() { return this.visible; },
      set(val) { this.$emit('update:visible', val); }
    },
    roomName() {
      if (!this.qrData) return '';
      return this.qrData.RoomName || this.qrData.roomName || '';
    },
    subject() {
      if (!this.qrData) return '';
      return this.qrData.Subject || this.qrData.subject || '';
    },
    h5Url() {
      if (!this.qrData) return '';
      return this.qrData.QrUrl || this.qrData.qrUrl || '';
    },
    qrContent() {
      if (!this.qrData) return '';
      return this.qrData.QrContent || this.qrData.qrContent || '';
    }
  },
  watch: {
    qrData: {
      deep: true,
      immediate: true,
      handler() {
        this.renderQrImage();
      }
    },
    visible(val) {
      if (val) this.renderQrImage();
    }
  },
  mounted() {
    if (this.visible && this.qrData) {
      this.renderQrImage();
    }
  },
  methods: {
    async renderQrImage() {
      if (!this.visible || !this.qrData) {
        this.qrImageUrl = '';
        this.qrRendering = false;
        return;
      }
      const content = this.qrContent || this.h5Url;
      if (!content) {
        this.qrImageUrl = '';
        this.qrRendering = false;
        return;
      }
      const renderSeq = ++this.qrRenderSeq;
      this.qrRendering = true;
      try {
        const dataUrl = await QRCode.toDataURL(String(content), {
          width: 240,
          margin: 2,
          errorCorrectionLevel: 'M'
        });
        if (renderSeq !== this.qrRenderSeq) return;
        this.qrImageUrl = dataUrl;
      } catch (e) {
        if (renderSeq !== this.qrRenderSeq) return;
        this.qrImageUrl = '';
        this.$message.error('二维码生成失败');
      } finally {
        if (renderSeq === this.qrRenderSeq) {
          this.qrRendering = false;
        }
      }
    },
    downloadQr() {
      if (!this.qrImageUrl) return;
      const namePart = this.subject || this.roomName || 'qrcode';
      const safeName = String(namePart).replace(/[\\/:*?"<>|]/g, '_');
      const link = document.createElement('a');
      link.href = this.qrImageUrl;
      link.download = `${this.downloadPrefix}_${safeName}.png`;
      link.click();
    },
    handleClosed() {
      this.qrRenderSeq += 1;
      this.qrImageUrl = '';
      this.qrRendering = false;
    }
  }
};
</script>

<style scoped>
.mr-qr-body {
  min-height: 120px;
  text-align: center;
}
.mr-qr-meta {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.mr-qr-sub {
  margin-top: 6px;
  color: #606266;
  font-size: 14px;
}
.mr-qr-img-wrap {
  margin: 16px auto 12px;
  width: 240px;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mr-qr-img {
  width: 240px;
  height: 240px;
}
.mr-qr-empty {
  color: #909399;
  font-size: 13px;
}
</style>
